/************************************
MODULE:    helper functions for history & hashchange manipulations
WHAT IT DOES:   helps to reduce code in other modules
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {

    var historyApi =  {
        addQueryParametrToUrl: function(url, parametr, value) {
            var regex = new RegExp("(\\?|\\&)(" + parametr + "=)([^&#]*)"),
                parts = url.toString().split('#'),
                url = parts[0],
                hash = parts[1],
                qstring = /\?.+$/,
                newURL = url;
            if (regex.test(url)) {
                newURL = url.replace(regex, '$1$2'+value);
            } else {
                newURL += qstring.test(url) ? '&' : '?';
                newURL = newURL + parametr + '=' + value;
            }
            if (hash)
                newURL += '#' + hash;
            return newURL;
        },

        addAllQueryParametrsToUrl: function(url, params) {
            var paramArr = Object.keys(params).sort();
            for(var i=0, l=paramArr.length; i<l; i++) {
                url = historyApi.addQueryParametrToUrl(url, paramArr[i], params[paramArr[i]]);
            }
            return url;
        },


        getQueryParametr: function (url, parametr) {
            if (!url)
                return "";

            var regex = new RegExp("[\\?|\\&]" + parametr + "=([^&#]*)"),
                results = regex.exec(url);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        },

        //getting all query string parameters and putting them into result object
        getAllQueryParametrs: function(url) {
            var result = {},
                //getting query string - between ? and #
                regex = new RegExp("[\?]([^#]*)"),
                regexApplied = regex.exec(url);

            if(!regexApplied || regexApplied.length < 2) {
                return result;
            }

            regexApplied[1].replace(/([^=&]+)=([^&]*)/g, function(m, key, value) {
                result[decodeURIComponent(key)] = decodeURIComponent(value);
                return '';
            });

            return result;
        },

        removeQueryParametr: function (url, parametr) {
            var regex = new RegExp("(\\?|\\&)(" + parametr + "=)([^&#]*)");
            if (regex.test(url)) {
                url = url.replace(regex, '');
            }
            return url;
        },

        removeAllQueryParametrs: function(url) {
            //getting query string - between ? and #
            var regex = new RegExp("[\?]([^#]*)");
            return url.replace(regex, '');
        },

        getFromSessionStorage: function (item) {
            var value = null;
            try {
                value = typeof sessionStorage == 'undefined' ? null : sessionStorage.getItem(item);
            } catch (e) {

            }
            return value == null || value == 'null' ? null : value;
        },

        getJsonFromSessionStorage: function (item) {
            var value = historyApi.getFromSessionStorage(item);
            try{
                value = JSON.parse(value);
                return value instanceof Array ? value : [];
            } catch (ex) {
                return [];
            }
            return value == null  || value == '' ? [] : JSON.parse(value);
        },

        setToSessionStorage: function(item, value) {
            if (typeof sessionStorage == 'undefined')
                return;

            try {
                sessionStorage.setItem(item, value);
            } catch (e) {

            }
        },

        setJsonToSessionStorage: function(item, value) {
            if(!(value instanceof Array))
                return;
            historyApi.setToSessionStorage(item, JSON.stringify(value));
        },

        addToHistory: function (url) {
            if (typeof window.history == 'undefined' || typeof window.history.pushState != 'function')
                return;
            window.history.pushState({}, document.title, url)
        },

        goByHistory: function(step) {
            if (typeof window.history == 'undefined' || typeof window.history.go != 'function')
                return;
            window.history.go(step);
        },

        isSessionAndHistory: typeof window.history != 'undefined' && typeof window.sessionStorage != 'undefined'

    }

    return historyApi;

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.history.js
 ** module id = 18
 ** module chunks = 24
 **/